<template>
  <div class="iso">
    <div class="container">
      <div class="images">
        <div class="image" v-for="(item,index) in images" :key="index">
          <el-image :preview-src-list="imageSrcList" fit="contain" :src="item.url" lazy/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Honor",
  mounted() {
    this.imageSrcList = this.images.map(item=>item.url)
  },
  data(){
    return{
      images:[
        {url:require('../../assets/images/certification/patents/荣誉证书(7).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(8).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(9).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(10).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(11).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(12).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(13).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(14).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(15).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(16).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(17).jpg')},
        {url:require('../../assets/images/certification/patents/荣誉证书(18).jpg')},
      ],
      imageSrcList:[]
    }
  }
}
</script>

<style lang="less" scoped>
.iso{
  height: 632px;
  overflow-y: scroll;
  text-align: center;
  &::-webkit-scrollbar{
    display:none
  }
  .container{
    width: 80%;
    display: inline-block;
    .images {
      margin: 5px 0;
      .image {
        font-size: 28px;
        display: inline-block;
        .el-image{
          margin: 5px 20px;
          width: 216px;
        }
      }
    }
  }
}


</style>
